import { types } from "mobx-state-tree";
import {
  minLower,
  minUpper,
  minSpecial,
  minNumbers,
  betweenMinAndMax,
} from "../../../helpers/passwordHintMessage";
import Constants from "../../../constants/text-constants";

const PasswordHintStore = types
  .model("PasswordHintStore", {
    passwordHints: types.map(types.number),
  })
  .actions((self) => ({
    setPasswordHints(newHints) {
      for (let key of Object.keys(newHints)) {
        self.passwordHints.set(key, newHints[key]);
      }
    },
  }))
  .views((self) => ({
    get passwordHintsText() {
      let numericRules = [];
      let lastRule;

      let hintText = betweenMinAndMax(
        self.passwordHints.get("minLength"),
        self.passwordHints.get("maxLength")
      );

      const sumOfNumericRules =
        self.passwordHints.get("minLower") +
        self.passwordHints.get("minNumbers") +
        self.passwordHints.get("minSpecial") +
        self.passwordHints.get("minUpper");

      if (sumOfNumericRules > 0) {
        if (self.passwordHints.get("minLower") > 0) {
          numericRules.push(minLower(self.passwordHints.get("minLower")));
        }
        if (self.passwordHints.get("minUpper") > 0) {
          numericRules.push(minUpper(self.passwordHints.get("minUpper")));
        }
        if (self.passwordHints.get("minNumbers") > 0) {
          numericRules.push(minNumbers(self.passwordHints.get("minNumbers")));
        }
        if (self.passwordHints.get("minSpecial") > 0) {
          numericRules.push(minSpecial(self.passwordHints.get("minSpecial")));
        }

        // we just have one rule
        if (numericRules.length === 1) {
          hintText += " " +
            Constants.PASSWORDS_MUST_CONTAIN + " " + numericRules.join(" ");
        } else {
          lastRule = numericRules.pop();
          hintText += " " + Constants.PASSWORDS_MUST_CONTAIN + " ";
          hintText += numericRules.join(", ");
          hintText += " and " + lastRule + ".";
        }
      }
      return hintText;
    },
  }));

export default PasswordHintStore;
